import * as yup from 'yup';
import { constantesRequerimentos } from '@utils';
import { declaracao } from './utils/rulesByKey';

const {
  VITALICIA_S_R_RCM,
  VITALICIA_C_R_RCM,
  CONJUGADA_S_R_RCM,
  CONJUGADA_C_R_RCM,
} = constantesRequerimentos;

export const ConversaoMATSchema = yup.object({
  ...declaracao,
  opcaoBeneficio: yup
    .string()
    .oneOf(
      [
        VITALICIA_S_R_RCM,
        VITALICIA_C_R_RCM,
        CONJUGADA_S_R_RCM,
        CONJUGADA_C_R_RCM,
      ],
      'Obrigatório assinalar uma opção.'
    )
    .required(),

  percentualRCM: yup
    .number()
    .integer()
    .when('opcaoBeneficio', {
      is: (value) => value === VITALICIA_C_R_RCM || value === CONJUGADA_C_R_RCM,
      then: (field) =>
        field
          .min(1, 'Valor deve estar entre 1 e 100')
          .max(100, 'Valor deve estar entre 1 e 100')
          .required('Atenção, Selecione o Percentual de RCM'),
    }),

  percentualRetiradaMensal: yup
    .number()
    .float(2, 'Máximo de duas casas após a virgula')
    .when('opcaoBeneficio', {
      is: (value) => value === CONJUGADA_C_R_RCM || value === CONJUGADA_S_R_RCM,
      then: (field) =>
        field
          .min(0.1, 'Valor deve estar entre 0.10 e 1')
          .max(1, 'Valor deve estar entre 0.10 e 1')
          .required('Atenção, Preencha o Percentual de retirada mensal'),
    }),

  percentualSaldoDeContasEmRendaVitalicia: yup
    .number()
    .integer()
    .when('opcaoBeneficio', {
      is: (value) => value === CONJUGADA_C_R_RCM || value === CONJUGADA_S_R_RCM,
      then: (field) =>
        field
          .min(50, 'Valor deve estar entre 50 e 99')
          .max(99, 'Valor deve estar entre 50 e 99')
          .required('Atenção, Selecione o Percentual em Renda Vitalícia'),
    }),
});

export const ConversaoMATInitialValues = {
  opcaoBeneficio: '',
  percentualRCM: '',
  percentualRetiradaMensal: '',
  percentualSaldoDeContasEmRendaVitalicia: '',
  declaracao: false,
};
